module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('a', {
    staticClass: "text-blue-400 hover:text-blue-600",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openHelp = !_vm.openHelp
      }
    }
  }, [_vm._v(_vm._s(_vm.openHelp ? 'OK, cool' : 'What is this?'))])]), _vm._v(" "), (_vm.openHelp) ? _c('div', {
    staticClass: "mb-6"
  }, [_vm._m(0), _vm._v(" "), (!_vm.listPage) ? _c('pre', {
    staticClass: "bg-yellow-300 mb-2 p-1"
  }, [_vm._v("Dallas // Fun food & drink spots\n")]) : _vm._e(), _vm._v(" "), (_vm.listPage) ? _c('pre', {
    staticClass: "bg-yellow-300 mb-2 p-1"
  }, [_vm._v("Lucia // Crazy good Italian\nSmall Brewpub\nTrompo Tacos // Yummy simple place\nHonor Bar\nHoundstooth // Delicious coffee\n")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left w-full p-4 text-sm bg-gray-200"
  }, [_c('a', {
    staticClass: "text-blue hover:text-blue-700",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/thatericsmith"
    }
  }, [_vm._v("@thatericsmith")]), _vm._v(" and \n          "), _c('a', {
    staticClass: "text-blue hover:text-blue-700",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/jbsmith2004"
    }
  }, [_vm._v("@jbsmith2004")]), _vm._v(" made "), _c('strong', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("Best Spots")]), _vm._v(" for you."), _c('br'), _c('br'), _vm._v("\n          Come here and paste a city and a list of places that you recommend, or that friends have recommended."), _c('br'), _vm._v("We'll google each spot and give you a link so you can remember them."), _c('br'), _c('br'), _vm._v("\n          Here's an example you can paste in and try:\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45db25d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpBox.vue
// module id = 158
// module chunks = 1